const pillars = [
  {
    icon: "ri-award-line",
    title: "Trusted, Premium Brands",
    desc: "We carry only proven, premium-grade power systems from manufacturers built to perform in real outage and off-grid conditions — not gear designed to pass a spec sheet.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Real-World Reliability",
    desc: "Every system we sell is vetted for actual home and property use. If it wouldn&apos;t hold up during a 3-day storm outage, it doesn&apos;t make our shelves.",
  },
  {
    icon: "ri-user-voice-line",
    title: "Expert Guidance",
    desc: "Not sure what you need? We help homeowners, rural property owners, and off-grid buyers find the right solution — without the upsell pressure or confusing tech talk.",
  },
  {
    icon: "ri-tools-line",
    title: "DIY or Pro Install Ready",
    desc: "Most of our systems are plug-and-play for DIY setup. For complex whole-home installs, we point you toward professional installation resources so you&apos;re covered either way.",
  },
];

export default function WhyTrustUs() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-amber-500 text-xs font-bold uppercase tracking-widest">Why Buy From Us</span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mt-2">
            Why Choose <span className="text-amber-500">Iron Haven Supply</span>
          </h2>
          <p className="text-gray-500 mt-3 max-w-2xl mx-auto text-sm leading-relaxed">
            We&apos;re not just another online store. We&apos;re a U.S.-based authorized dealer focused on helping families, homeowners, and property owners find the right backup power solution — with real support and no guesswork.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((p) => (
            <div key={p.title} className="flex flex-col items-center text-center bg-gray-50 rounded-xl p-6">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full mb-4">
                <i className={`${p.icon} text-amber-400 text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{p.title}</h3>
              <p
                className="text-gray-500 text-xs leading-relaxed"
                dangerouslySetInnerHTML={{ __html: p.desc }}
              />
            </div>
          ))}
        </div>

        {/* Installation callout */}
        <div className="mt-10 bg-gray-950 rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 rounded-full flex-shrink-0">
            <i className="ri-tools-fill text-amber-400 text-xl"></i>
          </div>
          <div className="flex-1">
            <h3 className="text-white font-bold text-sm mb-1">DIY-Friendly or Professionally Installed</h3>
            <p className="text-gray-400 text-xs leading-relaxed">
              Most of our portable and expandable backup systems are designed for simple, tool-free setup at home. For whole-home standby generators and advanced solar integrations, we can point you toward professional installation options — so there&apos;s a path forward no matter your skill level or project scope.
            </p>
          </div>
          <a
            href="/installation-guides"
            className="bg-amber-500 hover:bg-amber-400 text-white font-bold px-5 py-2.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            View Install Guides
          </a>
        </div>
      </div>
    </section>
  );
}
